import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as BS from 'react-bootstrap';
import Box from '../../atoms/Box';
import SpreadsheetReportConfigs from '../../../models/SpreadsheetReportConfigs/index.js';
import GoogleProfile from '../../../models/SpreadsheetReportConfigs/GoogleProfile.js';
import {
  createGooglePickerObject,
  loadGoogleScript,
} from '../../../lib/GoogleScript.js';

const scope =
  'frontend.components.SpreadsheetReportConfigs.Form.SpreadsheetForm';

const propTypes = {
  googleProfile: PropTypes.shape(GoogleProfile.propTypes),
  spreadsheetReportConfigs: PropTypes.shape(SpreadsheetReportConfigs.propTypes),
  onGoogleLogin: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  onRefreshAccessToken: PropTypes.func,
};

const SpreadsheetForm = ({
  googleProfile,
  spreadsheetReportConfigs: _spreadsheetReportConfigs,
  onGoogleLogin,
  onSubmit,
  onRefreshAccessToken,
}) => {
  const [isGoogleScriptLoaded, setIsGoogleScriptLoaded] = useState(false);

  useEffect(() => {
    loadGoogleScript().then(() => {
      setIsGoogleScriptLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (!!googleProfile && isGoogleScriptLoaded) {
      handleGooglePickerLoad();
    }
  }, [!!googleProfile, isGoogleScriptLoaded]);

  const handleSelectFileCallback = (data) => {
    if (
      data[window.google.picker.Response.ACTION] ===
      window.google.picker.Action.PICKED
    ) {
      const file = data[window.google.picker.Response.DOCUMENTS][0];
      const fileId = file[window.google.picker.Document.ID];

      onSubmit({
        sheetId: fileId,
      });
    }
  };

  const handleGooglePickerLoad = async () => {
    let currentGoogleProfile = googleProfile;

    if (googleProfile.expiresAt < Date.now()) {
      const refreshedProfile = await onRefreshAccessToken();
      if (refreshedProfile) {
        currentGoogleProfile = refreshedProfile;
      }
    }

    if (
      !currentGoogleProfile ||
      !currentGoogleProfile.accessToken ||
      !currentGoogleProfile.googleAppId
    ) {
      return;
    }

    if (!window.google?.picker) {
      return;
    }
    createGooglePickerObject(currentGoogleProfile, handleSelectFileCallback);
  };

  return (
    <Box>
      <Box.Header>
        <Box.Title>
          {I18n.t(`${scope}.fileSelectionSection.sectionTitle`)}
        </Box.Title>
      </Box.Header>
      <Box.Body>
        <div style={{ textAlign: 'left', padding: '20px' }}>
          <div
            style={{
              marginBottom: '20px',
              color: '#666',
              fontSize: '14px',
              lineHeight: '1.5',
              whiteSpace: 'pre-wrap',
            }}
          >
            <span>{I18n.t(`${scope}.fileSelectionSection.description`)}</span>
          </div>
          <BS.Button
            bsStyle='primary'
            style={{ padding: '9px 12px' }}
            onClick={onGoogleLogin}
          >
            <i
              className='fa fa-file-excel-o'
              style={{ marginRight: '8px' }}
            ></i>
            {I18n.t(`${scope}.action.selectFile`)}
          </BS.Button>
        </div>
      </Box.Body>
    </Box>
  );
};

SpreadsheetForm.propTypes = propTypes;

export default SpreadsheetForm;
